import '../../../style/collapse.scss'
import foldIcon from '@/public/components/query-table/assets/col-fold.png'
import unFoldIcon from '@/public/components/query-table/assets/col-unfold.png'

export function createCollapse () {
  return {
    functional: true,
    render (_, context) {
      const props = context.props
      const wrapperClass = 'kye-virtual-collapse'
      return <span class={wrapperClass} on-click={(event) => {
        event.stopPropagation()
        props.handleCollapsed()
      }}>
        <img src={ props.collapsed ? unFoldIcon : foldIcon} />
      </span>
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/feature/collapse/index.js